<template>
    <validation-provider
        v-slot="{ classes, errors }"
        class="dropdown-input"
        tag="div"
        :rules="rules"
        :name="name"
        :vid="vid"
    >
        <label class="input__label" :for="name">
            {{ name }} <span v-if="classes['required']">*</span>
        </label>
        <v-selector
            :id="name"
            v-model="currentValue"
            class="dropdown-input__input"
            :class="classes"
            :clearable="false"
            :searchable="false"
            :options="options"
            :reduce="option => option.id"
            label="name"
            :multiple="false"
            @input="emitValue"
        >
        </v-selector>

        <span class="input-error">{{ errors[0] }}</span>
    </validation-provider>
</template>

<script>
import vSelector from 'vue-select';
import { ValidationProvider } from 'vee-validate';
import _ from 'lodash';

export default {
    components: {
        ValidationProvider,
        vSelector
    },
    props: {
        value: {
            type: [String, Number],
            default: null
        },
        rules: {
            type: [String, Object],
            default: ''
        },
        name: {
            type: String,
            default: ''
        },
        vid: {
            type: String,
            default: undefined
        },
        options: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            currentValue: null
        };
    },
    watch: {
        value: function() {
            this.currentValue = this.value;
        }
    },
    created() {
        this.currentValue = this.value;
        this.getOptions();
    },
    methods: {
        emitValue() {
            this.$emit('input', this.currentValue);
        },
        getOptions() {
            if (this.options != null && this.options != undefined) {
                for (let i = 0; i < this.options.length; i++) {
                    if (
                        this.options[i].takeObjectInSelect != undefined &&
                        this.options[i].takeObjectInSelect != null &&
                        this.options[i].takeObjectInSelect == true
                    ) {
                        const newOption = _.clone(this.options[i]);
                        delete newOption.id;
                        this.options[i].id = newOption;
                    }
                }
            }
        }
    }
};
</script>

<style lang="scss">
.dropdown-input {
    .v-selector {
        font-size: 1.125rem;
        &.vs--open {
            opacity: 1;
        }
    }

    .vs__dropdown-toggle {
        border-radius: 5px;
        box-shadow: none;
        padding: 10px;
    }

    .vs__selected,
    .vs__search,
    .vs__search:focus {
        margin: 0;
        padding: 0;
        line-height: 1;
        border: none;
    }

    .vs__search {
        min-height: 21px;
    }
}
</style>
